import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../hooks/redux.js";
import Loading from "../components/common/Loading/Loading.js";


export default function Index() {
  const navigate = useNavigate();
  const shop = useAppSelector((state) => state.shop.data);

  useEffect(() => {
    if(shop && !shop.subscriptionPlan) {
      navigate(`/onboarding`);
      return
    }

    navigate(`/dashboard`);
  }, [shop]);

  return <Loading />;
}
